var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMintimage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_214_8752)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#7C4AF1"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_214_8752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2496 23.552L23.5519 24.7504C23.2216 24.7793 22.9164 24.9382 22.7033 25.1921C22.4902 25.4461 22.3867 25.7743 22.4156 26.1046L23.3961 37.3117C23.425 37.642 23.5839 37.9473 23.8378 38.1604C24.0918 38.3735 24.42 38.4769 24.7503 38.448L38.448 37.2497C38.7782 37.2208 39.0835 37.0619 39.2966 36.8079C39.5097 36.5539 39.6131 36.2257 39.5843 35.8955L38.6037 24.6883C38.5749 24.358 38.4159 24.0528 38.162 23.8397C37.908 23.6266 37.5798 23.5231 37.2496 23.552ZM32.9067 27.6963C33.0914 27.6801 33.2768 27.7191 33.4394 27.8083C33.6019 27.8974 33.7344 28.0328 33.82 28.1973C33.9056 28.3618 33.9406 28.5479 33.9204 28.7322C33.9002 28.9166 33.8258 29.0908 33.7066 29.2328C33.5874 29.3748 33.4288 29.4783 33.2508 29.5302C33.0728 29.5821 32.8834 29.58 32.7065 29.5243C32.5297 29.4685 32.3734 29.3616 32.2573 29.217C32.1412 29.0724 32.0707 28.8966 32.0545 28.7119C32.0328 28.4642 32.1105 28.218 32.2703 28.0276C32.4301 27.8371 32.659 27.7179 32.9067 27.6963ZM38.339 36.0044L24.6413 37.2028L24.3737 34.1434L27.6646 30.2205C27.7174 30.1576 27.782 30.1057 27.8549 30.0677C27.9277 30.0298 28.0073 30.0066 28.0891 29.9994C28.171 29.9922 28.2534 30.0013 28.3317 30.026C28.41 30.0507 28.4827 30.0906 28.5456 30.1435L34.2449 34.9243C34.372 35.0309 34.5362 35.0827 34.7014 35.0682C34.8666 35.0538 35.0193 34.9743 35.1259 34.8472C35.2325 34.7202 35.2843 34.556 35.2698 34.3908C35.2554 34.2255 35.1759 34.0728 35.0488 33.9662L33.5542 32.7128L34.5726 31.4983C34.6791 31.3715 34.8317 31.2921 34.9967 31.2776C35.1618 31.2632 35.3258 31.3149 35.4528 31.4213L38.1352 33.675L38.339 36.0044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6098 36.2317L38.3608 36.2535L24.6631 37.4519L24.4141 37.4736L24.3923 37.2246L24.1246 34.1652L24.1156 34.062L24.1821 33.9827L27.473 30.06C27.473 30.0599 27.4731 30.0599 27.4731 30.0599C27.5469 29.9718 27.6374 29.8991 27.7394 29.846C27.8413 29.7929 27.9528 29.7604 28.0673 29.7504C28.1819 29.7403 28.2973 29.753 28.407 29.7876C28.5166 29.8222 28.6183 29.878 28.7063 29.9519L38.6098 36.2317ZM38.6098 36.2317L38.5881 35.9826L38.3843 33.6532L38.3752 33.5502L38.296 33.4836L35.6136 31.2299L35.6134 31.2298C35.4357 31.0807 35.206 31.0084 34.975 31.0286C34.7439 31.0488 34.5303 31.1599 34.3811 31.3376L34.381 31.3377L33.3627 32.5522L33.202 32.7437L33.3936 32.9044L34.8882 34.1577C34.9644 34.2217 35.0121 34.3134 35.0208 34.4126C35.0295 34.5117 34.9984 34.6103 34.9344 34.6865C34.8704 34.7628 34.7788 34.8105 34.6796 34.8192C34.5804 34.8279 34.4819 34.7968 34.4056 34.7328L34.4056 34.7328L28.7064 29.952L38.6098 36.2317ZM23.5737 24.9994L37.2713 23.801C37.5356 23.7779 37.7981 23.8607 38.0013 24.0312C38.2045 24.2017 38.3316 24.4459 38.3547 24.7101L39.3352 35.9173C39.3583 36.1815 39.2755 36.444 39.1051 36.6472C38.9346 36.8504 38.6904 36.9775 38.4262 37.0006L24.7285 38.199C24.4643 38.2221 24.2017 38.1393 23.9985 37.9688C23.7954 37.7984 23.6683 37.5542 23.6451 37.29L22.6646 26.0828C22.6415 25.8186 22.7243 25.556 22.8948 25.3528C23.0653 25.1497 23.3095 25.0225 23.5737 24.9994ZM33.5596 27.5891C33.3537 27.4761 33.1189 27.4267 32.8849 27.4472C32.5712 27.4747 32.2812 27.6256 32.0788 27.8669C31.8763 28.1081 31.778 28.4199 31.8055 28.7337C31.8259 28.9677 31.9153 29.1903 32.0623 29.3735C32.2093 29.5566 32.4074 29.6921 32.6314 29.7627C32.8553 29.8333 33.0953 29.836 33.3207 29.7702C33.5462 29.7045 33.7471 29.5734 33.8981 29.3935C34.0491 29.2136 34.1433 28.9929 34.1689 28.7595C34.1945 28.526 34.1502 28.2902 34.0418 28.0819C33.9333 27.8735 33.7655 27.702 33.5596 27.5891Z",
    stroke: "#101010",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_214_8752",
    x: 0.333331,
    y: 0.333331,
    width: 61.3333,
    height: 61.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.66667,
    dy: 2.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.764706 0 0 0 0 0.807843 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_214_8752"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.66667,
    dy: -2.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_214_8752",
    result: "effect2_dropShadow_214_8752"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_214_8752",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_214_8752",
    x: 22.4102,
    y: 23.5472,
    width: 18.1797,
    height: 15.9056,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_214_8752"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_214_8752",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintimage);
export default __webpack_public_path__ + "static/media/mintimage.d6c39927614e5d2190c804b458fec6d8.svg";
export { ForwardRef as ReactComponent };